import { NgModule } from '@angular/core';
import { MontantPatternDirective } from "./montant-pattern.directive";
import { DigitOnlyDirective } from "./digit-only.directive";
import { DigitOnlyABDirective } from "./digit-only-with-ab.directive";
import { IfErrorDirective } from "./if-error.directive";

@NgModule( {
    imports: [],
    declarations: [DigitOnlyABDirective, MontantPatternDirective, DigitOnlyDirective, IfErrorDirective],
    exports: [DigitOnlyABDirective, MontantPatternDirective, DigitOnlyDirective, IfErrorDirective]
} )
export class DirectivesModule { }
